<div class="offers-comparison-panel-offer">
    <span class="material-icons offers-comparison-panel-offer__remove-btn"
          (click)="removeOffer()">
        highlight_off
    </span>
    <div class="offers-comparison-panel-offer__price">
        <app-offer-fixed-price [offer]="offer"
                               [showInstalment]="false"
        ></app-offer-fixed-price>
    </div>
    <div class="offers-comparison-panel-offer__logo">
        <img alt=""
             [src]="logoUrl">
    </div>
    <div class="offers-comparison-panel-offer__coverages">
        <ng-container *ngFor="let primaryBox of primaryBoxes">
            <app-offer-primary-box class="offer-primary-box"
                                   *ngIf="canShowBox(primaryBox.options, primaryBox.selectedOption, primaryBox.enabled)"
                                   [box]="primaryBox">
            </app-offer-primary-box>
        </ng-container>
    </div>
</div>
